/** Строка категории для построения дерева (без expand). */
export type CategoryRow = { id: string; name: string; parent?: string; sort?: number }

export function buildChildrenByParent(rows: CategoryRow[]): Map<string, CategoryRow[]> {
  const map = new Map<string, CategoryRow[]>()
  for (const r of rows) {
    const p = typeof r.parent === 'string' && r.parent ? r.parent : ''
    const arr = map.get(p) ?? []
    arr.push(r)
    map.set(p, arr)
  }
  for (const arr of map.values()) {
    arr.sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0) || a.name.localeCompare(b.name, 'ru'))
  }
  return map
}

/** Все id узла rootId и его потомков (включая rootId). */
export function collectSubtreeIds(rows: CategoryRow[], rootId: string): string[] {
  const byParent = buildChildrenByParent(rows)
  const out: string[] = []
  const walk = (id: string) => {
    out.push(id)
    for (const ch of byParent.get(id) ?? []) {
      walk(ch.id)
    }
  }
  walk(rootId)
  return out
}
